export const mapKeyToSortKey: Record<string, string> = {
  applicationName: 'application__name',
  applicationEmail: 'application__email',
  created: 'created',
  jobTitle: 'job_title',
  applicationNumMessages: 'application_num_messages',
  jobStageName: 'job_stage_name',
};

export const pageSize = 100;
